<template>
  <div class="flex flex-col bg-white w-96 shadow-lg border border-neutral-100 rounded-lg p-12">
    <div class="flex items-center justify-center space-x-2.5">
      <fa
        :icon="['fas', 'star']"
        class="fa-fw text-2xl text-bubblegum"
      />
      <fa
        :icon="['fas', 'star']"
        class="fa-fw text-2xl text-bubblegum"
      />
      <fa
        :icon="['fas', 'star']"
        class="fa-fw text-2xl text-bubblegum"
      />
      <fa
        :icon="['fas', 'star']"
        class="fa-fw text-2xl text-bubblegum"
      />
      <fa
        :icon="['fas', 'star']"
        class="fa-fw text-2xl"
        :class="{
          'text-bubblegum': review.rating_overall === '5.0',
          'text-pink-200': review.rating_overall === '4.0',
        }"
      />
    </div>

    <div class="mt-6 text-base leading-6 text-center text-neutral-900 h-32">
      “{{ getText }}”
    </div>

    <div class="flex justify-center items-center mt-6">
      <div class="h-10 w-10 mr-4 rounded-full shrink-0 bg-ocean-900 inline-flex items-center justify-center font-bold text-xl text-white">
        {{ review.author[0] }}
      </div>
      <div>
        <div class="text-neutral-900 font-medium text-base">
          {{ review.author }}
        </div>
        <div class="text-neutral-500 text-sm font-light -mt-2">
          {{ createdAt }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { monthYearFromISO } from '@/helpers/dateUtils';

library.add(faStar);

export default {
  name: 'VetsterReviewSliderTile',

  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  computed: {
    createdAt() {
      return monthYearFromISO(this.review.created_at);
    },
    getText() {
      const cutoff = 150;
      if (this.review.body.length < cutoff) {
        return this.review.body;
      }

      return `${this.review.body.substring(0, cutoff)}...`;
    },
  },
};
</script>
